export default {
	SMALL_ICONS: 'small-icons',
	BIG_ICONS: 'big-icons',
	BIGGER_ICONS: 'bigger-icons',
}
